import { useTheme } from "./ThemeProvider";

const TIPO_LABEL = {
  todos:      { label: "Todos",        icon: "🌐", desc: "Cualquier tipo de anunciante" },
  agencia:    { label: "Agencias",     icon: "🏢", desc: "Solo inmobiliarias y agencias" },
  particular: { label: "Particulares", icon: "👤", desc: "Solo propietarios particulares" },
};

export default function ModalPortales({ onClose, criterios, onSeleccionar }) {
  const { theme } = useTheme();
  const isDark = theme.name === "dark";

  const bg = isDark ? "#1a1f2e" : "#ffffff";
  const textPrimario = isDark ? "#f1f5f9" : "#0f172a";
  const textSecundario = isDark ? "#94a3b8" : "#64748b";
  const borderColor = isDark ? "#2e3650" : "#e2e8f0";
  const bgHover = isDark ? "#242938" : "#f0f9ff";

  // Chips de criterios activos
  const chips = [
    criterios?.op && (criterios.op.charAt(0).toUpperCase() + criterios.op.slice(1)),
    criterios?.tipos?.length > 0 && criterios.tipos.join(", "),
    criterios?.pobls?.length > 0 && criterios.pobls.join(", "),
    criterios?.pMax && `Hasta ${Number(criterios.pMax).toLocaleString("es-ES")} €`,
    criterios?.hMin && `${criterios.hMin}+ hab.`,
    criterios?.extras?.length > 0 && criterios.extras.slice(0, 3).join(", "),
  ].filter(Boolean);

  const seleccionar = (tipo) => {
    onSeleccionar(tipo);
    onClose();
  };

  return (
    <div
      style={{ position: "fixed", inset: 0, zIndex: 1100, background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center" }}
      onClick={onClose}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: bg, borderRadius: 16, width: 360,
          boxShadow: isDark
            ? "0 0 0 1px rgba(255,255,255,0.08), 0 16px 48px rgba(0,0,0,0.7)"
            : "0 8px 40px rgba(0,0,0,0.18)",
          overflow: "hidden",
        }}
      >
        <div style={{ height: 3, background: "linear-gradient(90deg, #0369a1, #0ea5e9)" }} />

        <div style={{ padding: "16px 20px 12px", display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ width: 36, height: 36, borderRadius: 8, flexShrink: 0, background: "linear-gradient(135deg, #0369a1, #0284c7)", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <svg width={18} height={18} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/>
              <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
            </svg>
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: textPrimario }}>Buscar en portales</div>
            <div style={{ fontSize: 11, color: textSecundario, marginTop: 1 }}>BD de scraping · resultados en tiempo real</div>
          </div>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: textSecundario, fontSize: 18, padding: 4 }}>✕</button>
        </div>

        {chips.length > 0 && (
          <div style={{ padding: "0 20px 12px", display: "flex", flexWrap: "wrap", gap: 5 }}>
            {chips.map((tag, i) => (
              <span key={i} style={{ fontSize: 10, padding: "2px 8px", borderRadius: 20, background: isDark ? "#1e3a5f" : "#dbeafe", color: isDark ? "#7dd3fc" : "#1d4ed8", fontWeight: 500 }}>{tag}</span>
            ))}
          </div>
        )}

        <div style={{ height: 1, background: borderColor, margin: "0 20px" }} />

        <div style={{ padding: "14px 20px 18px", display: "flex", flexDirection: "column", gap: 8 }}>
          <div style={{ fontSize: 11, color: textSecundario, marginBottom: 2 }}>¿Qué tipo de anunciante quieres ver?</div>
          {Object.entries(TIPO_LABEL).map(([key, { label, icon, desc }]) => (
            <button
              key={key}
              onClick={() => seleccionar(key)}
              style={{
                display: "flex", alignItems: "center", gap: 12,
                padding: "11px 14px", borderRadius: 10,
                border: `1.5px solid ${borderColor}`,
                background: bgHover, cursor: "pointer",
                textAlign: "left", width: "100%", transition: "all 0.15s",
              }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = "#0369a1"; e.currentTarget.style.background = isDark ? "#1e3a5f" : "#dbeafe"; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = borderColor; e.currentTarget.style.background = bgHover; }}
            >
              <span style={{ fontSize: 22, flexShrink: 0 }}>{icon}</span>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: textPrimario }}>{label}</div>
                <div style={{ fontSize: 11, color: textSecundario, marginTop: 1 }}>{desc}</div>
              </div>
              <span style={{ fontSize: 12, color: "#0369a1" }}>→</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
